module.exports = __webpack_public_path__ + "static/QuoteBuilder-f7bff6981cf723f23df518bbb967a838.png";